import React from 'react';

const ShowerIcon = (props) => {
  return (
    <img
      alt="Prysznic"
      src="/static/images/icons/services/shower.svg"
      {...props}
    />
  );
};

export default ShowerIcon;
